import { http } from 'utils'
import { SET_ITEMS, ADD_ITEMS, SET_META } from 'vx/mutations'
import { concat } from 'lodash'

export default {
  namespaced: true,

  state: {
    stations: [],
    meta: null
  },

  actions: {
    async getStations ({ commit }, { params = {} } = {}) {
      const response = await http.get('stations')

      commit(ADD_ITEMS, response.data.data)

      return response
    },

    resetStations ({ commit }) {
      commit(SET_ITEMS, [])
    }
  },

  mutations: {
    [SET_ITEMS] (state, items) {
      state.stations = items
    },

    [ADD_ITEMS] (state, items) {
      state.stations = concat(state.stations, items)
    },

    [SET_META] (state, meta) {
      state.meta = meta
    }
  }
}
